export const metersToKm = (meters: number) => {
  return meters ? meters / 1000 : undefined;
};

export const kmToMeters = (kms: number) => {
  return kms ? kms * 1000 : undefined;
};
